/**
 * @generated SignedSource<<6ece7e4e8d6fca884ce28ed9f1bc2c45>>
 * @relayHash 96592abf784f3c9dafe0eea521c9dbf1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a944d20036e03ef24145ba4f9591e3a421ad44fd439a63ffc0cbeb893f7c9a9d

import type { ConcreteRequest } from 'relay-runtime';
export type usePageIncludeMacroQueryByTitleQuery$variables = {
  spaceKey: string;
  title: string;
};
export type usePageIncludeMacroQueryByTitleQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly body: {
        readonly atlas_doc_format: {
          readonly mediaToken: {
            readonly token: string | null;
          } | null;
          readonly value: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly space: {
        readonly id: string | null;
        readonly key: string | null;
      } | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
};
export type usePageIncludeMacroQueryByTitleQuery = {
  response: usePageIncludeMacroQueryByTitleQuery$data;
  variables: usePageIncludeMacroQueryByTitleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "title"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              (v1/*: any*/)
            ]
          },
          {
            "concreteType": "ContentBodyPerRepresentation",
            "kind": "LinkedField",
            "name": "body",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "atlas_doc_format",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  },
                  {
                    "concreteType": "EmbeddedMediaToken",
                    "kind": "LinkedField",
                    "name": "mediaToken",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "token"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePageIncludeMacroQueryByTitleQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePageIncludeMacroQueryByTitleQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "96592abf784f3c9dafe0eea521c9dbf1",
    "id": "a944d20036e03ef24145ba4f9591e3a421ad44fd439a63ffc0cbeb893f7c9a9d",
    "metadata": {},
    "name": "usePageIncludeMacroQueryByTitleQuery",
    "operationKind": "query",
    "text": "query usePageIncludeMacroQueryByTitleQuery($spaceKey:String!,$title:String!){content(spaceKey:$spaceKey,title:$title,first:1){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}}}"
  }
};
})();

(node as any).hash = "5dc9ee980e0bdd0afa15444bc7f11bd6";

export default node;
